import { Component, OnInit, OnDestroy } from '@angular/core';
import { DataService } from './../../../../services/data.service';
import { VendorService } from './../../../../services/vendor.service';
import { TableSearchPipe } from './../../../../pipes/table-search.pipe';
import { VendorDocument } from '../../../../models/VendorDocument';
import { VendorComponent } from '../../vendor.component';

@Component({
  selector: 'app-invoices-view',
  templateUrl: './invoices-view.component.html',
  styleUrls: ['./invoices-view.component.scss']
})
export class InvoicesViewComponent implements OnInit, OnDestroy {
  userInfo: any;
  public searchText: string = '';
  invoicePg:number = 1;
  selectedInvPerPageVal = '10 per page';
  invoices:any = [];
  invoicesFilter:string = 'Open';
  invSortBy:any = '';
  invSortOrder:string = 'asc';
  data:any;
  private alive = true;
  vendorDoc: VendorDocument;
  public ItmPerPage: any = [{ id: 1, name: '10', value: '10 per page' },
  { id: 2, name: '25', value: '25 per page' },
  { id: 3, name: '50', value: '50 per page' }];
  constructor(private datasvc: DataService, private vendorsvc: VendorService) { }

  ngOnInit() {
    this.userInfo = this.datasvc.userDisplayInfo;
        this.getVendorInv();

  }

  getVendorInv() {
    this.vendorsvc.getInvoicesView(this.searchText, this.userInfo.GPVID).takeWhile(() => this.alive).subscribe(
      inv => {
        this.invoices = inv;
        console.log('Vendor data', this.invoices);

      });
  }
getInvoiceDetails(invNumber: string) {

  this.vendorDoc = new VendorDocument();
    this.vendorsvc.getInvoiceDetails(invNumber, this.userInfo.GPVID).takeWhile(() => this.alive).subscribe(
      data => {
        this.vendorDoc = data;
        console.log('Vendor data', this.vendorDoc);

      });

}

  ngOnDestroy() {
    this.alive = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/vendor/my-vendor/invoices-view/invoices-view.component.ts